import * as THREE from 'three';
import { BackendHardnessToFrontend, Hardness } from './consts';

export const DEFAULT_RONDOM_MEDIUM_COLOR = new THREE.Color(0x787878);
export const DEFAULT_RONDOM_SOFT_COLOR = new THREE.Color(0xc7c7c7);
export const DEFAULT_RONDOM_EXTRASOFT_COLOR = new THREE.Color(0xebebeb);
export const RONDOM_PRESSUURE_PIXEL_WIDTH = 0.274;
export const RONDOM_PRESSURE_INSOLE_LENGTH_GAP = 4;

export const RONDOM_getColorByHardness = (hardness: Hardness | null | undefined) => {
    if (!hardness) return DEFAULT_RONDOM_MEDIUM_COLOR;
    const frontHardness = BackendHardnessToFrontend(hardness);
    if (frontHardness === null || frontHardness === undefined) return DEFAULT_RONDOM_MEDIUM_COLOR;

    if (frontHardness === Hardness.ExtraSoft) return DEFAULT_RONDOM_EXTRASOFT_COLOR;
    else if (frontHardness === Hardness.Soft) return DEFAULT_RONDOM_SOFT_COLOR;
    else return DEFAULT_RONDOM_MEDIUM_COLOR;
}